import { Button, Table, TableCard } from "@light-technology/components";
import { Role } from "../../state/api.types";
import { useAuthHasRole } from "../../state/hooks";
import { RoleGate } from "../RoleGate";
import { InviteTeammateModal } from "./InviteTeammateModal";
import { InvitesList } from "./InvitesList";
import { MembersList } from "./MembersList";

type TeammatesCardProps = {
  orgSlug: string;
  currentUserEmail: string;
};

export const TeammatesCard = ({
  orgSlug,
  currentUserEmail,
}: TeammatesCardProps) => {
  const isAdmin = useAuthHasRole(Role.OrgAdmin);

  return (
    <TableCard.Root>
      <TableCard.Header
        title="Teammates"
        contentTrailing={
          <InviteTeammateModal orgSlug={orgSlug}>
            <Button
              isDisabled={!isAdmin}
              data-ph-capture-attribute-action="invite-teammates"
            >
              Invite teammates
            </Button>
          </InviteTeammateModal>
        }
      />
      <Table aria-label="Teammates">
        <Table.Header>
          <Table.Head isRowHeader id="member" label="Member" />
          <Table.Head id="email" label="" />
          <Table.Head id="permissions" label="Permissions" />
          <Table.Head id="actions" label="" className="w-0 whitespace-nowrap" />
        </Table.Header>
        <Table.Body>
          <RoleGate roles={[Role.OrgAdmin]}>
            <InvitesList orgSlug={orgSlug} />
          </RoleGate>
          <MembersList orgSlug={orgSlug} currentUserEmail={currentUserEmail} />
        </Table.Body>
      </Table>
    </TableCard.Root>
  );
};
